import { CloudUploadOutlined, DeleteOutlined, DoubleRightOutlined, EditOutlined, ExclamationCircleOutlined, WalletOutlined, WarningOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Card, DatePicker, Divider, Form, Input, InputNumber, Modal, Select, Spin, Table, Tooltip } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import HeaderTitle from '../../component/HeaderTitle/HeaderTitle';
import mDisputeControllers from '../../control/dispute/index.controllers';
import mHelper from './../../config/Helper';
import * as XLSX from 'xlsx';

var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));


const layout = {
    labelCol: {
        span: 10,
    },
    wrapperCol: {
        span: 14,
    },
};

const layoutPendukung = {
    labelCol: {
        span: 5,
    },
    wrapperCol: {
        span: 19,
    },
};



var thisComponent;
var formUploadDispute = React.createRef();
const { Option } = Select;
const { TextArea } = Input;
const { confirm } = Modal;
class UploadDispute extends Component {

    constructor(props) {
        super(props);
        this.state = {
            AdCode: isLogin.company.ad_code,
            AdName: isLogin.company.ad_name,
            TableUploadDispute: [],
            Periode: mHelper.GET_DATE_DIGIPOS(),
            modalFormUploadDispute: false,
            barReconALookup: [],
            barReconBLookup: [],
            loadingUploadDispute: false,
            loadingdDetDispute: false,
            fileRekapTransaksi: [],
            TableTrxDispute: [],
            DisputeSelected: 0,
            typeTrx: 1,
            sales_fee: 0,
            dealer_code : "",
            qty_trx: 0,
            actionDisputeDetail: "INSERT",
            DisputeDetSelected: 0,
            tmpDataExcel :[],
            successImportExl : [],
            errorImportExl : [],
            dealerALookup : [],
            dealerDataLookup : {}
        };
        thisComponent = this;
    }

    async componentDidMount() {
        this.onRefreshDataDispute();
        this.onRefreshDealerLookup();
    }


    onProcessDispute = () => {
        this.onRefreshDataDispute();
    }

    onChangeDisputeType = (values) => {
        this.setState({typeTrx : parseInt(values)});
        this.onRefreshBarReconLookup(this.state.Periode,parseInt(values));
        this.onUpdateDataispute({ type_trx: parseInt(values) });
    }

    onChangeDisputeBarRecon = (values) => {
        this.onUpdateDataispute({ no_bar: values });
    }


    onRefreshBarReconLookup = (periode, type) => {
        this.setState({ loadingUploadDispute : true });
        mDisputeControllers.GET_DATA_BAR({ periode: periode, type_trx: type }, (r) => {
            var datas = [];
            for (var i in r) {
                var rowBar = r[i];
                datas.push({
                    key: rowBar.id,
                    value: rowBar.bar_no,
                    label: rowBar.bar_no
                });
            }
            this.setState({ barReconALookup: datas , loadingUploadDispute : false });
        });
    }

    onRefreshDealerLookup = () => {
        this.setState({ loadingUploadDispute : true });
        mDisputeControllers.GET_DEALER({ where :{ad_code:this.state.AdCode  } }, (r) => {
            
            var datas = [];
            for (var i in r) {
                var rowBar = r[i];
                this.state.dealerDataLookup[rowBar.ad_cluster_id] = rowBar;
                datas.push({
                    key: rowBar.ad_cluster_id,
                    value:rowBar.ad_cluster_id,
                    label: rowBar.ad_name + " ( "+ rowBar.ad_cluster_name+ " )"
                });
            }
            this.setState({ dealerALookup: datas , loadingUploadDispute : false });
        });
    }

    

    onRefreshDataDispute = () => {
        // this.setState({loadingUploadNotaDebet: true});
        this.state.loadingUploadDispute = true;
        var filter = { where: { and: [{ periode: this.state.Periode }, { ad_code: this.state.AdCode }] } };
        mDisputeControllers.GET_DATA_DISPUTE(filter, (r) => {
            var datas = [];
            for (var i in r) {
                var disputRaw = r[i];
                var status = ["Draft", "Waiting Validate...", "Validate", "Reject"];
                var type = ["NONE", "RECHARGE A", "RECHARGE B", "PPOB"];
                datas.push({
                    key: disputRaw.dispute_id,
                    action: disputRaw.dispute_id,
                    periode_trx: disputRaw.periode,
                    type_trx: type[disputRaw.type_trx],
                    ad_code: disputRaw.ad_code,
                    ad_name: disputRaw.ad_name,
                    bar_number: disputRaw.no_bar,
                    sales_fee: disputRaw.sales_fee,
                    qty_trx:  disputRaw.qty_trx == null ? "" : mHelper.GENERATE_PULUHAN(disputRaw.qty_trx),
                    total_amount:  disputRaw.tot_mdr == null ? "" : mHelper.GENERATE_PULUHAN(disputRaw.tot_mdr),
                    dpp_amount: disputRaw.dpp_amount,
                    ppn_amount: disputRaw.ppn_amount,
                    pph_amount: disputRaw.pph_amount,
                    remarks: disputRaw.remarks,
                    file: {
                        key: i,
                        info: {
                            docRekapTrx: "LA.0820.0820-0001.csv"
                        }
                    },
                    status: status[disputRaw.dispute_status],
                    note : disputRaw.note
                });
            }
            this.setState({ TableUploadDispute: datas, loadingUploadDispute: false });
        });

    }

    onRefreshDataTrxDispute = () => {
        this.setState({ loadingdDetDispute: true });
        mDisputeControllers.GET_DETAIL_DISPUTE(this.state.DisputeSelected, (r) => {
            var datas = [];
            for (var i in r) {
                var rawDet = r[i];
                datas.push({
                    key: rawDet.dispute_det_id,
                    // action: rawDet.dispute_det_id,
                    dealer_code:rawDet.dealer_code,
                    sales_fee: rawDet.sales_fee == null ? "" : "Rp." + mHelper.GENERATE_PULUHAN(rawDet.sales_fee),
                    qty_trx: rawDet.qty_trx == null ? "" : mHelper.GENERATE_PULUHAN(rawDet.qty_trx),
                    tot_mdr: rawDet.tot_mdr == null ? "" : "Rp." + mHelper.GENERATE_PULUHAN(rawDet.tot_mdr),
                    dpp_amount: rawDet.dpp_amount == null ? "" : "Rp." + mHelper.GENERATE_PULUHAN(rawDet.dpp_amount),
                    ppn_amount: rawDet.ppn_amount == null ? "" : "Rp." + mHelper.GENERATE_PULUHAN(rawDet.ppn_amount),
                    pph_amount: rawDet.pph_amount == null ? "" : "Rp." + mHelper.GENERATE_PULUHAN(rawDet.pph_amount)
                });
            }
            this.setState({ loadingdDetDispute: false, TableTrxDispute: datas });
        });
    }

    onUploadDispute = () => {
        this.setState({ modalFormUploadDispute: true, loadingUploadDispute: true });
        mDisputeControllers.ADD_DISPUTE_DRAFT(
            this.state.Periode,
            this.state.AdCode == null ? "-" : this.state.AdCode,
            this.state.AdName == null ? "-" : this.state.AdName,
            this.state.typeTrx,
            (r) => {
                setTimeout(() => {
                    formUploadDispute.current.resetFields();
                    formUploadDispute.current.setFieldsValue({
                        ad_code: this.state.AdCode,
                        ad_name: this.state.AdName,
                        periode: moment(this.state.Periode, 'YYYY-MM'),
                        dispute_type: this.state.typeTrx.toString()
                    });
                    this.setState({ loadingUploadDispute: false, DisputeSelected: r.data.dispute_id });
                    this.onRefreshBarReconLookup(this.state.Periode, this.state.typeTrx);
                    this.onRefreshDataTrxDispute();
                }, 2000);
            });
    }

    onChangeDate = (date, dateString) => {
        // console.log(dateString);
        this.setState({ Periode: dateString });
    }

    onChangeDateDisputeForm = (date, dateString) => {
        this.setState({ Periode: dateString });
        this.onUpdateDataispute({ periode: dateString, no_bar: "" });
        formUploadDispute.current.setFieldsValue({ bar_number: "" });
        this.onRefreshBarReconLookup(dateString, this.state.typeTrx);
    }


    onCancelFormUploadDispute = () => {
        this.setState({ modalFormUploadDispute: false });
        this.onRefreshDataDispute();
    }

    onFinishFormUploadDispute = (row) => {
        this.setState({ modalFormUploadDispute: true });
        mDisputeControllers.SUBMIT_DISPUTE(this.state.DisputeSelected, (r) => {
            if (r.success == true) {
                this.onRefreshDataDispute();
                mHelper.ON_SEND_MESSAGE_NOTIF({
                    types: "NOTIFICATION",
                    target: "1,2,3,4,5,6,7,8",
                    to: "",
                    from_who: this.state.AdCode,
                    subject: "Data Dispute telah disubmit oleh AD ",
                    body: "Document Dispute berhasil di submit oleh : "+ this.state.AdName,
                    path_url: "",
                    app: "DIGIPOS",
                    code: "17010101",
                    code_label: "",
                    at_create: mHelper.CURRENT_TIME_MILIS(),
                    at_read: "",
                    periode:  this.state.Periode,
                    at_flag: 0
                });
            }
            this.setState({ modalFormUploadDispute: false });
        })
    }

    onChangePriceDispute = (values) => {
        // console.log(values);
        var Price = values == "" || values == null ? 0 : values;
        var Pph = (parseInt(values) * 0.1);
        var Total = Price + Pph;
        formUploadDispute.current.setFieldsValue({
            total_amount: Total,
            vat_amount: Pph
        });
    }


    handleOpenFile = (e, key) => {
        // console.log(e.key, key);
    }

    onUpdateDataispute = (raw) => {
        var info = {};
        console.log(raw);
        info["periode"] = this.state.Periode;
        info["ad_code"] = this.state.AdCode;
        info["ad_name"] = this.state.AdName;
        info["type_trx"] = this.state.typeTrx;
        // info[key] = values;
        for (var i in raw) {
            info[i] = raw[i];
        }
        mDisputeControllers.UPDATE_DISPUTE_DATA(this.state.DisputeSelected, info, (r) => {
            // console.log(r);
        });
    }

    handelUpdateDispute = (text) => {
        this.setState({ loadingUploadDispute: true });
        mDisputeControllers.GET_SELECT_DISPUTE(text, (r) => {
            if (r.dispute_status != 0) {
                this.setState({ loadingUploadNotaDebet: false });
                Modal.info({
                    title: 'Error',
                    content: (
                        <div>
                            <p>Tidak bisa merubah  dispute kecuali status dipute draft !</p>
                        </div>
                    ),
                    onOk() { },
                });
                return;
            }
            this.setState({ modalFormUploadDispute: true, DisputeSelected: text });
            setTimeout(() => {
                formUploadDispute.current.resetFields();
                formUploadDispute.current.setFieldsValue({
                    ad_code: this.state.AdCode,
                    ad_name: this.state.AdName,
                    periode: moment(r.periode, 'YYYY-MM'),
                    dispute_type: r.type_trx.toString(),
                    bar_number: r.no_bar,
                    remarks: r.remarks
                });

                this.onRefreshBarReconLookup(r.periode, r.type_trx);
                this.onRefreshDataTrxDispute();
                this.setState({ loadingUploadDispute: false, TableTrxDispute: r.dispute_detail, typeTrx : r.type_trx });
            }, 2000);
        });
    }

    handelDeleteDispute = (text) => {
        mDisputeControllers.GET_SELECT_DISPUTE(text, (r) => {
            if (r.dispute_status != 0) {
                this.setState({ loadingUploadNotaDebet: false });
                Modal.info({
                    title: 'Error',
                    content: (
                        <div>
                            <p>Tidak bisa merubah  dispute kecuali status dipute draft !</p>
                        </div>
                    ),
                    onOk() { },
                });
                return;
            }
            confirm({
                title: 'Submit Invoice',
                icon: <ExclamationCircleOutlined />,
                content: 'Kamu yakin ingin menhapus data dispute detail ini ?',
                onOk() {
                    thisComponent.setState({ loadingUploadDispute: true });
                    mDisputeControllers.DELETE_DISPUTE(text, (r) => {
                        thisComponent.onRefreshDataDispute();
                        thisComponent.setState({ loadingUploadDispute: false });
                    })
                },
                onCancel() {
                },
            });
        });
    }

    onChangeDealerCode = (values) => {
        var DealerCode = values == "" || values == null ? "" : values;
        this.setState({ dealer_code: DealerCode });
    }

    onChangeSalesFee = (values) => {
        var SalesFee = values == "" || values == null ? 0 : values;
        this.setState({ sales_fee: SalesFee });
    }

    onChangeQtyTrx = (values) => {
        var QtyTrx = values == "" || values == null ? 0 : values;
        this.setState({ qty_trx: QtyTrx });
    }

    onAddTrxDetDisput = () => {
        // console.log(this.state.qty_trx, this.state.sales_fee);
        var dealer_code = this.state.dealer_code;
        var sales_fee = this.state.sales_fee;
        var qty = this.state.qty_trx;
        if (sales_fee == "" || qty == ""|| dealer_code == "" || sales_fee == null || qty == null || dealer_code == null) {
            Modal.info({
                title: 'Error',
                content: (
                    <div>
                        <p>Dealer Code, Sales Fee dan Qty Transaksi wajib diisi ! !</p>
                    </div>
                ),
                onOk() { },
            });
            return;
        }

        if (this.state.actionDisputeDetail == "INSERT") {
            this.setState({ loadingUploadDispute: true });
            mDisputeControllers.ADD_DETAIL_DISPUTE(dealer_code, sales_fee, qty, this.state.DisputeSelected, (r) => {
                if (r.success == true) {
                    formUploadDispute.current.setFieldsValue({dealer_code : "" , sales_fee: 0, qty_trx: 0 });
                    this.onRefreshDataTrxDispute();
                } else {
                    formUploadDispute.current.setFieldsValue({dealer_code : "" , sales_fee: 0, qty_trx: 0 });
                    this.setState({ loadingdDetDispute: false });
                }
                this.setState({ loadingUploadDispute: false });
            });
        }

        if (this.state.actionDisputeDetail == "UPDATE") {
            this.setState({ loadingdDetDispute: true });
            mDisputeControllers.UPDATE_DETAIL_DISPUTE(this.state.DisputeDetSelected,dealer_code, sales_fee, qty, this.state.DisputeSelected, (r) => {
                if (r.success == true) {
                    formUploadDispute.current.setFieldsValue({ dealer_code : "" ,sales_fee: 0, qty_trx: 0 });
                    this.onRefreshDataTrxDispute();
                } else {
                    formUploadDispute.setFieldsValue({dealer_code : "" , sales_fee: 0, qty_trx: 0 });
                }
                this.setState({ loadingdDetDispute: false, actionDisputeDetail: "INSERT" });
            });
        }

    }

    handelUpdateDetailDispute = (text) => {
        this.setState({ loadingUploadDispute: true });
        mDisputeControllers.GET_DETAIL_DISPUTE_SELECT(text, (r) => {
            formUploadDispute.current.setFieldsValue({ dealer_code : r.dealer_code, sales_fee: r.sales_fee, qty_trx: r.qty_trx, dispute_type : r.type_trx });
            this.setState({ loadingUploadDispute: false, DisputeDetSelected: text, actionDisputeDetail: "UPDATE",dealer_code : r.dealer_code, sales_fee: r.sales_fee, qty_trx: r.qty_trx, typeTrx : r.type_trx  });
        });
    }

    handelDeleteDetailDispute = (text) => {
        confirm({
            title: 'Submit Invoice',
            icon: <ExclamationCircleOutlined />,
            content: 'Kamu yakin ingin menhapus data dispute detail ini ?',
            onOk() {
                thisComponent.setState({ loadingUploadDispute: true });
                mDisputeControllers.DELETE_DETAIL_DISPUTE(text, (r) => {
                    thisComponent.setState({ loadingUploadDispute: false, actionDisputeDetail: "INSERT" });
                    formUploadDispute.current.setFieldsValue({ sales_fee: 0, qty_trx: 0 });
                    thisComponent.onRefreshDataTrxDispute();
                })
            },
            onCancel() {
            },
        });
    }

    handleChangeUploadExel = (file) => {
        // file.preventDefault();
        this.setState({ loadingUploadDispute: true });
        var files = file.target.files, f = files[0];
        var reader = new FileReader();
        reader.onload = function (e) {
            var data = e.target.result;
            let readedData = XLSX.read(data, {type: 'binary'});
            const wsname = readedData.SheetNames[0];
            const ws = readedData.Sheets[wsname];
            /* Convert array to json*/
            // const dataParse = XLSX.utils.sheet_to_json(ws, {header:1});
            const dataParse = XLSX.utils.sheet_to_json(ws, {header:1});
            // console.log("Data>>>",dataParse);
            var rolName = [];
            var pathExcel = {"SPB_NAME" : -1, "DEALER_CODE" : -1, "YY" : -1, "MM" : -1, "SALES_FEE" : -1, "TRX_A" : -1, "TOT_MDR_A" : -1};
            var AccExcelColumn = ["SPB_NAME","DEALER_CODE","YY","MM","SALES_FEE","TRX_A","TOT_MDR_A"];


            if(thisComponent.state.typeTrx == 1){
                pathExcel = {"SPB_NAME" : -1, "DEALER_CODE" : -1, "YY" : -1, "MM" : -1, "SALES_FEE" : -1, "TRX_A" : -1, "TOT_MDR_A" : -1};
                AccExcelColumn = ["SPB_NAME","DEALER_CODE","YY","MM","SALES_FEE","TRX_A","TOT_MDR_A"];
            }

            
            if(thisComponent.state.typeTrx == 2){
                pathExcel = {"SPB_NAME" : -1, "DEALER_CODE" : -1, "YY" : -1, "MM" : -1, "SALES_FEE" : -1, "TRX_B" : -1, "TOT_MDR_B" : -1};
                AccExcelColumn = ["SPB_NAME","DEALER_CODE","YY","MM","SALES_FEE","TRX_B","TOT_MDR_B"];
            }

            if(thisComponent.state.typeTrx == 3){
                pathExcel = {"SPB_NAME" : -1, "DEALER_CODE" : -1, "YY" : -1, "MM" : -1, "SALES_FEE" : -1, "TRX_A" : -1, "TOT_MDR_PPOB" : -1};
                AccExcelColumn = ["SPB_NAME","DEALER_CODE","YY","MM","SALES_FEE","TRX_A","TOT_MDR_PPOB"];
            }

            var indexPotition = [];
            var insertData = true;
            var message = "";
            var dealerNotAva = [];
            for(var i in dataParse){
                var rawInfo = dataParse[i];
                if(i == 0){
                    rolName = rawInfo;
                    var AllAvaliable = true;
                    for(var j in AccExcelColumn){
                        if(rolName.indexOf(AccExcelColumn[j]) == -1){
                            AllAvaliable = false;
                        }else{
                            pathExcel[AccExcelColumn[j]] = j;
                        }
                    }
                    if(AllAvaliable == false){
                        insertData = false;
                        message = "Format file field excel failed !";
                        break;
                    }
                }else{
                    if( rawInfo[pathExcel["DEALER_CODE"]] == undefined){
                        continue;
                    }

                    if(thisComponent.state.typeTrx == 1){
                        indexPotition.push({
                            "DEALER_CODE" : rawInfo[pathExcel["DEALER_CODE"]].toString(), 
                            "PERIODE" : thisComponent.state.Periode, 
                            "SALES_FEE" : rawInfo[pathExcel["SALES_FEE"]], 
                            "TRX_A" : rawInfo[pathExcel["TRX_A"]], 
                            "TRX_B" : 0
                        });
                    }

                    
                    if(thisComponent.state.typeTrx == 2){
                        indexPotition.push({
                            "DEALER_CODE" : rawInfo[pathExcel["DEALER_CODE"]].toString(), 
                            "PERIODE" : thisComponent.state.Periode, 
                            "SALES_FEE" : rawInfo[pathExcel["SALES_FEE"]], 
                            "TRX_A" : 0, 
                            "TRX_B" : rawInfo[pathExcel["TRX_B"]]
                        });
                    }

                    if(thisComponent.state.typeTrx == 3){
                        indexPotition.push({
                            "DEALER_CODE" : rawInfo[pathExcel["DEALER_CODE"]].toString(), 
                            "PERIODE" : thisComponent.state.Periode, 
                            "SALES_FEE" : rawInfo[pathExcel["SALES_FEE"]], 
                            "TRX_A" : rawInfo[pathExcel["TRX_A"]], 
                            "TRX_B" : 0
                        });
                    }

                    if(thisComponent.state.dealerDataLookup[rawInfo[pathExcel["DEALER_CODE"]]] == undefined){
                        insertData = false;
                        dealerNotAva.push(rawInfo[pathExcel["DEALER_CODE"]]);
                        message = "Dealer Code untuk : "+JSON.stringify(dealerNotAva) + " tidak ditemukan !"
                    }
                }
            }

            if(insertData == false){
                alert(message);
                thisComponent.setState({ loadingUploadDispute: false, tmpDataExcel : []});
            }else{
                // console.log(indexPotition);
                thisComponent.setState({ loadingUploadDispute: true, tmpDataExcel : indexPotition});
                mDisputeControllers.RESET_TRX_DISPUTE(thisComponent.state.DisputeSelected,(r)=>{
                    if(r.success == true){
                        thisComponent.onRunningInsertExcel();
                    }else{
                        thisComponent.setState({ loadingUploadDispute: false, tmpDataExcel : []});
                    }
                })
            }
            file.target.value = null;
        };
        reader.readAsBinaryString(f);

        // var input = file.target.files[0]
        // var name = input.name;
        // const reader = new FileReader();
        // reader.onload = (evt) => { // evt = on_file_select event
        //     /* Parse data */
        //     const bstr = evt.target.result;
        //     const wb = XLSX.read(bstr, {type:'binary'});
        //     /* Get first worksheet */
        //     const wsname = wb.SheetNames[0];
        //     const ws = wb.Sheets[wsname];
        //     /* Convert array of arrays */
        //     const data = XLSX.utils.sheet_to_csv(ws, {header:1});
        //     /* Update state */
        //     console.log("Data>>>"+data);
        // };
    }

    onRunningInsertExcel = () => {
        var types =  thisComponent.state.typeTrx;
        var indexPotition = thisComponent.state.tmpDataExcel;
        if(indexPotition.length == 0){
            this.setState({ 
                loadingUploadDispute: false, 
                tmpDataExcel : thisComponent.state.tmpDataExcel, 
                successImportExl : thisComponent.state.successImportExl, 
                errorImportExl: thisComponent.state.errorImportExl 
            });
        }
        for(var i in indexPotition){
            var delIndex = i;
            var rawData = indexPotition[i];
            if(types == 1){
                //RECHARGE A
                mDisputeControllers.ADD_DETAIL_DISPUTE(rawData.DEALER_CODE, rawData.SALES_FEE, rawData.TRX_A, this.state.DisputeSelected, (r) => {
                    if (r.success == true) {
                        formUploadDispute.current.setFieldsValue({ dealer_code : "", sales_fee: 0, qty_trx: 0 });
                        thisComponent.state.successImportExl.push(delIndex);
                        this.onRefreshDataTrxDispute();
                    } else {
                        formUploadDispute.current.setFieldsValue({ dealer_code : "", sales_fee: 0, qty_trx: 0 });
                        thisComponent.state.errorImportExl.push(delIndex);
                    }
                    thisComponent.state.tmpDataExcel.splice(delIndex, 1);
                    thisComponent.onRunningInsertExcel();
                });
            }
            
            if(types == 2){
                //RECHARGE B
                mDisputeControllers.ADD_DETAIL_DISPUTE(rawData.DEALER_CODE, rawData.SALES_FEE, rawData.TRX_B, this.state.DisputeSelected, (r) => {
                    if (r.success == true) {
                        formUploadDispute.current.setFieldsValue({ dealer_code : "", sales_fee: 0, qty_trx: 0 });
                        thisComponent.state.successImportExl.push(delIndex);
                        this.onRefreshDataTrxDispute();
                    } else {
                        formUploadDispute.current.setFieldsValue({ dealer_code : "", sales_fee: 0, qty_trx: 0 });
                        thisComponent.state.errorImportExl.push(delIndex);
                    }
                    thisComponent.state.tmpDataExcel.splice(delIndex, 1);
                    thisComponent.onRunningInsertExcel();
                });
            }

            if(types == 3){
                //PPOB
                mDisputeControllers.ADD_DETAIL_DISPUTE(rawData.DEALER_CODE, rawData.SALES_FEE, rawData.TRX_A, this.state.DisputeSelected, (r) => {
                    if (r.success == true) {
                        formUploadDispute.current.setFieldsValue({ dealer_code : "", sales_fee: 0, qty_trx: 0 });
                        thisComponent.state.successImportExl.push(delIndex);
                        this.onRefreshDataTrxDispute();
                    } else {
                        formUploadDispute.current.setFieldsValue({ dealer_code : "", sales_fee: 0, qty_trx: 0 });
                        thisComponent.state.errorImportExl.push(delIndex);
                    }
                    thisComponent.state.tmpDataExcel.splice(delIndex, 1);
                    thisComponent.onRunningInsertExcel();
                });
            }
            break;
        }
    }
    
    columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: text => {
                return (
                    <div>
                        <Tooltip placement="bottom" title={"Edit Dispute Upload"}>
                            <Button type="primary" className="btn-tools btn-info" size="small" icon={<EditOutlined />} onClick={(e) => { this.handelUpdateDispute(text) }}></Button>
                        </Tooltip>
                        <Tooltip placement="bottom" title={"Delete Dispute Upload"}>
                            <Button type="danger" className="btn-tools" size="small" icon={<DeleteOutlined />} onClick={(e) => { this.handelDeleteDispute(text) }}></Button>
                        </Tooltip>
                    </div>
                )
            }
        },
        {
            title: 'Periode',
            dataIndex: 'periode_trx',
            key: 'periode_trx',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Type',
            dataIndex: 'type_trx',
            key: 'type_trx',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Kode AD',
            dataIndex: 'ad_code',
            key: 'ad_code',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Nama AD',
            dataIndex: 'ad_name',
            key: 'ad_name',
        },
        {
            title: 'Nomor BAR',
            dataIndex: 'bar_number',
            key: 'bar_number',
        },
        {
            title: 'Sales Fee',
            dataIndex: 'sales_fee',
            key: 'sales_fee',
        },
        {
            title: 'Qty',
            dataIndex: 'qty_trx',
            key: 'qty_trx',
        },
        {
            title: 'Total MDR',
            dataIndex: 'total_amount',
            key: 'total_amount',
        },
        // {
        //     title: 'DPP',
        //     dataIndex: 'dpp_amount',
        //     key: 'dpp_amount',
        // },

        // {
        //     title: 'PPN',
        //     dataIndex: 'ppn_amount',
        //     key: 'ppn_amount',
        // },

        // {
        //     title: 'PPH',
        //     dataIndex: 'pph_amount',
        //     key: 'pph_amount',
        // },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'remarks',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'Note',
            dataIndex: 'note',
            key: 'note',
            render: text => {
                if(text == "" || text == undefined || text == null){
                    return ("-")
                }else{
                    return (
                        <div>
                            <Tooltip placement="top" title={text}>
                                <Button  className="btn-tools btn-warning" size="small" style={{backgroundColor:"#FF0000",color:"#FFFFFF"}}><WarningOutlined /></Button>
                            </Tooltip>
                        </div>
                    )
                }
            }
        },
    ];

    columnsTrxDispute = [
        // {
        //     title: 'Action',
        //     dataIndex: 'action',
        //     key: 'action',
        //     render: text => {
        //         return (
        //             <div>
        //                 <Tooltip placement="bottom" title={"Edit Dispute Detail Upload"}>
        //                     <Button type="primary" className="btn-tools btn-info" size="small" icon={<EditOutlined />} onClick={(e) => { this.handelUpdateDetailDispute(text) }}></Button>
        //                 </Tooltip>
        //                 <Tooltip placement="bottom" title={"Delete Dispute Detail Upload"}>
        //                     <Button type="primary" className="btn-tools btn-success" size="small" icon={<DeleteOutlined />} onClick={(e) => { this.handelDeleteDetailDispute(text) }}></Button>
        //                 </Tooltip>
        //             </div>
        //         )
        //     }
        // },
        {
            title: 'Dealer Code',
            dataIndex: 'dealer_code',
            key: 'dealer_code',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Sales Fee',
            dataIndex: 'sales_fee',
            key: 'sales_fee',
            render: text => <span>{text}</span>,
        },
        {
            title: 'Qty Transaksi',
            dataIndex: 'qty_trx',
            key: 'qty_trx',
            render: text => <span>{text}</span>,
        },

        {
            title: 'Total Mdr',
            dataIndex: 'tot_mdr',
            key: 'tot_mdr',
            render: text => <span>{text}</span>,
        }
    ]
    render() {
        const { uploading, fileRekapTransaksi } = this.state;
        const fileRecapTransaksiProps = {
            onRemove: file => {
                this.setState(state => {
                    const index = state.fileRekapTransaksi.indexOf(file);
                    const newFileList = state.fileRekapTransaksi.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileRekapTransaksi: newFileList,
                    };
                });
            },
            beforeUpload: file => {
                this.setState(state => ({
                    fileRekapTransaksi: [...state.fileRekapTransaksi, file],
                }));
                return false;
            },
            fileRekapTransaksi,
        };

        return (
            <div >
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <div className="TitlePage">
                            <WalletOutlined className="icon" /><DoubleRightOutlined className="iconArrow" /> <h3>Upload Dispute</h3>
                        </div>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row>
                    <HeaderTitle onChangeDate={this.onChangeDate} onProcess={this.onProcessDispute} momen={moment(this.state.Periode, 'YYYY-MM')} />
                    <Col sm={12} lg={12}>
                        <Card bordered={false} className="box">
                            <Row>
                                <Col sm={12} lg={12} style={{ marginBottom: 20 }}>
                                    <Button className="primaryButton" icon={<CloudUploadOutlined />} onClick={this.onUploadDispute}>
                                        Upload Dispute
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12} lg={12}>
                                    <Table columns={this.columns} dataSource={this.state.TableUploadDispute} />
                                </Col>
                            </Row>
                            <Card style={{ boxShadow: '#E3EAFF 1px 1px 3px 1px' }}>
                                <Row>
                                    <Col sm={2} lg={2}>Waiting Validate...</Col><Col sm={10} lg={10}>: Menunggu data divalidasi oleh link aja.</Col>
                                    <Col sm={2} lg={2}>Validate</Col><Col sm={10} lg={10}>: Data fispute sudah divalidasi</Col>
                                </Row>
                            </Card>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    width="900px"
                    title="Form Upload Dispute"
                    visible={this.state.modalFormUploadDispute}
                    footer={null}
                    onCancel={this.onCancelFormUploadDispute}>
                    <Spin spinning={this.state.loadingUploadDispute} >
                        <Form {...layout} ref={formUploadDispute} name="disputeForm" onFinish={this.onFinishFormUploadDispute}>
                            <Row>
                                <Col sm={6} lg={6}>
                                    <Form.Item name="dispute_type"
                                        rules={[
                                            {
                                                required: true, message: 'Please input Type Dispute !',
                                            },
                                        ]}
                                        label="Type Dispute">
                                        <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            placeholder="Select dispute"
                                            onChange={this.onChangeDisputeType}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }  >

                                            <Select.Option value=""></Select.Option>
                                            <Select.Option value="1">RECHARGE A</Select.Option>
                                            <Select.Option value="2">RECHARGE B</Select.Option>
                                            <Select.Option value="3">PPOB</Select.Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item name="periode"
                                        rules={[
                                            {
                                                required: true, message: 'Please input Kode Transaksi  !',
                                            },
                                        ]}
                                        label="Periode">
                                        <DatePicker picker="month" onChange={this.onChangeDateDisputeForm} />
                                    </Form.Item>
                                    <Form.Item name="bar_number"
                                        rules={[
                                            {
                                                required: true, message: 'Please input Nomor BAR Recon !',
                                            },
                                        ]}
                                        label="Nomor BAR Recon">
                                        <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            onChange={this.onChangeDisputeBarRecon}
                                            placeholder="Select nomor bar recon"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }  >

                                            {this.state.barReconALookup.map((row) => (
                                                <Select.Option value={row.value}>{row.label}</Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col sm={6} lg={6}>
                                    <Form.Item name="ad_code"
                                        rules={[
                                            {
                                                required: true, message: 'Please input Kode AD  !',
                                            },
                                        ]}
                                        label="Kode AD">
                                        <Input placeholder="" readOnly />
                                    </Form.Item>
                                    <Form.Item name="ad_name"
                                        rules={[
                                            {
                                                required: true, message: 'Please input Nama AD  !',
                                            },
                                        ]}
                                        label="Nama AD">
                                        <Input placeholder="" readOnly />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Divider orientation="left">INFORMASI PENDUKUNG</Divider>
                            <Row>
                                <Col sm={12} lg={12} >
                                    <Form.Item name="remarks" {...layoutPendukung}
                                        rules={[
                                            {
                                                required: true, message: 'Please input Remarks  !',
                                            },
                                        ]}
                                        label="Remarks">
                                        <TextArea placeholder="" allowClear onChange={(e) => { this.onUpdateDataispute({ "remarks": e.target.value }) }} />
                                    </Form.Item>
                                    {/* <Form.Item name="rekap_transaksi" {...layoutPendukung}
                                        rules={[
                                            {
                                            required: true, message: 'Please  upload Rekap Transaksi  !',
                                            },
                                        ]}
                                        label="Doc Rekap Transaksi">
                                        <Upload {...fileRecapTransaksiProps}>
                                            <Button icon={<UploadOutlined />}>Select File  Rekap Transaksi</Button>
                                        </Upload>
                                    </Form.Item> */}
                                </Col>
                            </Row>

                            {/* <Divider orientation="left">Masukan Transaksi Dispute</Divider>
                            <Row>
                                <Col sm={6} lg={6} >
                                    <Form.Item name="dealer_code"
                                        label="Dealer Code">
                                        <Select
                                            showSearch
                                            style={{ width: 200 }}
                                            onChange={this.onChangeDealerCode}
                                            placeholder="Select Dealer"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            } >

                                            {this.state.dealerALookup.map((row) => (
                                                <Select.Option value={row.value}>{row.label}</Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col sm={6} lg={6} >

                                </Col>
                                <Col sm={6} lg={6} >
                                    <Form.Item name="sales_fee"
                                        label="Sales Fee">
                                        <InputNumber style={{ width: "100%" }}
                                            defaultValue={0}
                                            min={0}
                                            formatter={value => `RP ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/\RP\s?|(,*)/g, '')}
                                            onChange={this.onChangeSalesFee}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col sm={6} lg={6} >
                                    <Form.Item name="qty_trx"
                                        label="Qty Transaksi">
                                        <InputNumber style={{ width: "100%" }}
                                            defaultValue={0}
                                            min={0}
                                            defaultValue={0}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            onChange={this.onChangeQtyTrx}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row> */}
                            <Row>
                                <Col sm={12} lg={2} >
                                    UPLOAD EXEL
                                </Col>
                                <Col sm={12} lg={6} >
                                    <div style={{ marginBottom: 20 }}>
                                        <input type='file'accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={this.handleChangeUploadExel}  />
                                    </div>
                                </Col>
                                <Col sm={12} lg={4} >
                                    <div style={{ textAlign: 'right', marginBottom: 20 }}>
                                            {/* <Button className="primaryButton" onClick={this.onAddTrxDetDisput}>
                                                Tambah Transaksi Dispute
                                            </Button> */}
                                    </div>
                                </Col>
                            </Row>
                            <Spin spinning={this.state.loadingdDetDispute} >
                                <Table columns={this.columnsTrxDispute} dataSource={this.state.TableTrxDispute} />
                            </Spin>
                            <Divider />
                            <div style={{ textAlign: 'right' }}>
                                <Button className="primaryButton" htmlType="submit" >
                                    Submit Dispute
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </Modal>
            </div>
        )
    }
}


export default UploadDispute;
